import { useEffect, useState } from 'react';
import useKrpano from 'react-krpano-hooks';
import { useParams } from 'react-router';
import { useNavigate } from 'react-router-dom';
import { useEViewerStore } from '../../contexts/RootStoreProvider';
import ViewerPasswordDialog from "../../components/sharedprojects/dialogs/password";
import ExternalViewerHotspotDialog from "../../components/sharedprojects/dialogs/hotspot/index";
import { observer } from 'mobx-react';

function ExternalTourViewer() {
    let { id } = useParams();
    const [viewingXml, setViewingXml] = useState('');
    const eviewerStore = useEViewerStore();
    const navigate = useNavigate();
    const { containerRef, callKrpano } = useKrpano({
        embeddingParams: {
            xml: null,
            target: 'react-krpano'
        },
        width: '100%'
    }) as any;


    const getTourData = async (spId, password) => {

        if (password) { eviewerStore.setPassword(password); }

        await eviewerStore.getExternalViewingData(spId, password).then((result: any) => {

        }).catch((error: any) => { alert(error.message) })

    }



    useEffect(() => {
        if (id !== null && id !== undefined) {
            getTourData(id, undefined)
        }
        else {
            alert('No Shared Link Supplied !');
            navigate('/');
        }
    }, [id]);

    useEffect(() => {
        callKrpano("loadxml('" + eviewerStore.viewData + "',NULL, MERGE, BLEND(0.5));");
    }, [eviewerStore.viewData]);

    return (
        <>
            <div ref={containerRef} style={{ borderRadius: 10 }} />
            <ViewerPasswordDialog spId={id} submitPassword={getTourData} evStore={eviewerStore} open={eviewerStore.showPasswordDialog} />
            <ExternalViewerHotspotDialog eviewerStore={eviewerStore} spId={id} hotspotType='asset' handleClose={eviewerStore.clearDialogs} open={eviewerStore.showViewerDialog} />

        </>
    );
}

export default observer(ExternalTourViewer);

